import React, { useEffect } from "react";
import ImageWithLoader from "../components/ImageWithLoader";

const images = [
  "/g1.png",
  "/g2.png",
  "/g3.png",
  "/g4.png",
  "/g5.png",
  "/g6.png",
  "/g7.png",
  "/g8.png",
];

export default function Gallery2() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  return (
    <section className="min-h-screen bg-[#0a1f0d] py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <h1 className="text-white font-serif text-4xl md:text-5xl text-center mb-12">
          Gallery
        </h1>

        {/* GRID */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {images.map((src, i) => (
            <div key={i} className="rounded-xl overflow-hidden">
              <ImageWithLoader
                src={src}
                alt={`gallery-${i}`}
                className="h-[200px]"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}